import { h } from 'preact';
import { formatMoney } from '../utils/helpers';

const Price = ({
  currentPrice,
  currentComparePrice,
  classes,
  containerClass,
}) => (
  <div
    className={`justify-center laptop:justify-start flex ${
      currentComparePrice && 'product-prices'
    } ${containerClass}`}
  >
    <span className={`${classes}`}>
      {formatMoney({ amount: currentPrice * 100 }, true)}
    </span>
    {currentComparePrice && (
      <del className={`${classes} pl-1 text-secondary-1`}>
        {formatMoney({ amount: currentComparePrice * 100 }, true)}
      </del>
    )}
  </div>
);

export default Price;
